<div class="function-bar d-flex">
  <ng-content></ng-content>
</div>
